module.exports = __webpack_public_path__ + "img/tree_left_layout_icon.f60397b8.svg";